import type AuthScope from '../api/authScope'

const isUserAuthorized = (userScopes: string | AuthScope[], authScopes?: AuthScope[]) => {
  if (!authScopes) {
    return true
  }

  return authScopes.every((scope) => userScopes.includes(scope))
}

export default isUserAuthorized
